import { useState, React } from "react";
import axios from "axios";
export default function AddInstructorForm({ closeModal, setRenderToggle }) {
    const [full_name, setName] = useState("");
    const onNameChange = (e) => setName(e.target.value);
    function handleClick(e) {
        e.stopPropagation();
        const headers = {
            "Content-Type": "text/plain",
        };

        var postData = { full_name };
        axios
            .post("https://api.bollywoodfunknyc.com/instructors.php", postData, {
                headers,
            })
            .then((res) => {
                setRenderToggle((renderToggle) => !renderToggle);
            });
        closeModal();
    }
    return (
        <form>
            <label htmlFor="full_name" className="block text-sm font-medium text-gray-700">
                Instructor Full Name
            </label>
            <div className="mt-1">
                <input
                    type="text"
                    name="full_name"
                    id="full_name"
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    placeholder="eg. Ayesha Khanna"
                    onChange={onNameChange}
                    required
                />
            </div>

            <div className="mt-12 text-right">
                <button
                    type="button"
                    className="inline-flex mr-3 justify-center px-4 py-2 text-sm font-medium text-gray-900 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={closeModal}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    onClick={handleClick}
                >
                    Save
                </button>
            </div>
        </form>
    );
}
